import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  props.data['country_id'] = props.data.country?.id ?? ''
  props.data['state_id'] = props.data.state?.id ?? ''

  const formData = {
    ...props.data,
  }

  response = await axiosPost(apiUrls.customers, formData, (err: AxiosError) => {
    if (err.response!.status === 422) {
      let mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('country_id', 'country')
      mappedAttributes.set('state_id', 'state')
      mappedAttributes.set('city', 'city')
      setFormValidationError(err, props.setError, mappedAttributes, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  })

  return response
}

export default submitForm
